/**
 * useNotionExportState — manages Notion-specific state for export.
 *
 * Simplest of the three provider hooks. Notion requires no user configuration
 * (no project/team/label selection). Database is auto-created on first export.
 * This hook tracks workspace name + databaseId from providerMetadata; the
 * databaseId is what the project-schema field picker resolves against (no
 * project picker — Notion's "project" is its auto-created database).
 */
import { useState, useCallback } from 'react';
export function useNotionExportState(runtime) {
    const { debug } = runtime;
    const [workspaceName, setWorkspaceName] = useState(null);
    const [databaseId, setDatabaseId] = useState(null);
    /** Callback for useExportOAuth — Notion has no data to load */
    const onNotionConnected = useCallback((name, dbId) => {
        debug.log('Notion connected, workspace:', name, 'databaseId:', dbId);
        setWorkspaceName(name);
        setDatabaseId(dbId);
    }, [runtime]);
    /** Reset Notion-specific state */
    const resetNotionState = useCallback(() => {
        debug.log('Resetting Notion state');
        setWorkspaceName(null);
        setDatabaseId(null);
    }, [runtime]);
    return {
        workspaceName,
        databaseId,
        onNotionConnected,
        resetNotionState,
    };
}
//# sourceMappingURL=useNotionExportState.js.map